import { isAzServer } from './location';

export function getBackendBaseUrl() {
    const baseURL = window.location.hostname === OEM_FRONTEND_DOMAIN
        ? `https://${OEM_BACKEND_DOMAIN}/`
        : `https://${CONFIG_BACKEND_URL}/`;
    return CONFIG_BACKEND_URL ? baseURL : '/';
}

export type OEMNameType = 'default' | 'fasttel' | 'az';
export function getCurrentOEMName(): OEMNameType {
    if (isAzServer()) {
        return 'az';
    }
    if (SUPPORTED_OEM !== '' && window.location.hostname === OEM_FRONTEND_DOMAIN) {
        return SUPPORTED_OEM;
    }

    return 'default';
}

export default null;
